import { useDispatch } from 'react-redux'
import ExportButton from '../../common/ExportButton'
import TableFilter from './tableFilter'
import { helpDeskExportColumns } from '../../config/exportColumns/helpDeskExportColumns'
import { appAllGetHelpDesk } from '../../store/helpdesk'

function HelpDesk() {
	const dispatch = useDispatch()
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Help Desk</div>
					<div>
						<ExportButton
							fetchAction={params => dispatch(appAllGetHelpDesk({ ...params, loading: false }))}
							columns={helpDeskExportColumns}
							fileName="HelpDesk_Requests"
							sheetName="Help Desk"
							buttonText="Export Help Desk"
						/>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default HelpDesk
